// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"39689f12","213":"eb328e9a","239":"4ec92667","453":"cb95d025"}[chunkId] + ".chunk.js";
};